function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Notification"
}, React.createElement("path", {
  className: "cls-1",
  d: "M13.805,9.306l-1.541-1.79a1.321,1.321,0,0,1-.387-.935V5.058A4.972,4.972,0,0,0,7.143.238,4.871,4.871,0,0,0,2.1,4.864V6.581a1.321,1.321,0,0,1-.387.935L.2,9.306a.662.662,0,0,0,.468,1.129H13.338A.661.661,0,0,0,13.805,9.306Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M4.45,11.781A2.453,2.453,0,0,0,7,13.764a2.454,2.454,0,0,0,2.551-1.983Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/notification.2bd5087e.svg";
export { SvgComponent as ReactComponent };